import {all, takeLatest, put} from 'redux-saga/effects';
import {ETLDashboardActionType, loadETLStatuses} from 'SystemAdministration/ducks/etlDashboard';
import {get} from 'Shared/utilities/fetchHelpers';
import {ETLAggregateStatus} from 'SystemAdministration/models/ETLStatus';
import {AsyncResult, fromResult} from 'Core/models/Async';
import {pipe} from 'fp-ts/lib/pipeable';
import * as E from 'fp-ts/lib/Either';

function* getETLAggregateStatus() {
  yield takeLatest(ETLDashboardActionType.GET_ETL_STATUSES, function*() {
    const result: AsyncResult<ETLAggregateStatus> = yield get('/orchestration/processlogs/latest');

    yield pipe(
      result,
      E.map(fromResult),
      E.fold(
        value => put(loadETLStatuses(value)),
        value => put(loadETLStatuses(value))
      )
    );
  });
}

export default function*() {
  yield all([getETLAggregateStatus()]);
}
